import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.function.name";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Close from '@nerdwallet/react-icon/nerdwallet-ui/Close';
import { DEFAULT_PROVIDERS } from './images';
import { ElementInteraction } from '../tracking';
var propTypes = {
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  providers: PropTypes.array,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  triggerInteraction: PropTypes.func
};
var defaultProps = {
  providers: DEFAULT_PROVIDERS,
  onClick: function onClick() {},
  onClose: function onClose() {},
  triggerInteraction: function triggerInteraction() {}
};

var LoginPopover =
/*#__PURE__*/
function (_Component) {
  _inherits(LoginPopover, _Component);

  function LoginPopover(props) {
    var _this;

    _classCallCheck(this, LoginPopover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LoginPopover).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.toggleExpanded = _this.toggleExpanded.bind(_assertThisInitialized(_this));
    _this.state = {
      expanded: false
    };
    return _this;
  }

  _createClass(LoginPopover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.triggerInteraction('SHOW');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.triggerInteraction('HIDE');
    }
  }, {
    key: "toggleExpanded",
    value: function toggleExpanded() {
      // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate -- directive added automatically by Shepherd migration
      this.setState({
        expanded: !this.state.expanded
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(provider) {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.onClick(provider);
    }
  }, {
    key: "renderProviders",
    value: function renderProviders() {
      var _this2 = this;

      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var providersToRender = this.state.expanded ? // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.providers : // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.providers.slice(0, 3);
      return providersToRender.map(function (provider) {
        var onClick = function onClick() {
          _this2.handleClick(provider.name);
        };

        return React.createElement(ElementInteraction, {
          id: "nw-comment-box__login-popover-option",
          elementName: "nw-comment-box__login-popover-option",
          type: "CLICK",
          sectionCategory: "login",
          elementContent: provider.name
        }, React.createElement("div", {
          className: "login-popover__provider login-popover__item",
          onClick: onClick
        }, React.createElement("img", {
          className: "login-popover__provider-logo",
          alt: "".concat(provider.name, "-logo"),
          src: provider.icon
        }), React.createElement("span", {
          className: "login-popover__provider-name"
        }, provider.name)));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "login-popover"
      }, React.createElement("div", {
        className: "login-popover__item",
        onClick: this.props.onClose
      }, React.createElement("span", null, "Sign in with:"), React.createElement(Close, {
        className: "login-popover__close"
      })), this.renderProviders(), !this.state.expanded && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- directive added automatically by Shepherd migration
      React.createElement("div", {
        onClick: this.toggleExpanded,
        className: "login-popover__item login-popover__more"
      }, "Show more"));
    }
  }]);

  return LoginPopover;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


LoginPopover.displayName = 'LoginPopover'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

LoginPopover.propTypes = propTypes; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

LoginPopover.defaultProps = defaultProps;
export default LoginPopover;